
import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import ResetPasswordForm from "@/components/auth/ResetPasswordForm";
import ResetPasswordError from "@/components/auth/ResetPasswordError";
import ResetPasswordSuccess from "@/components/auth/ResetPasswordSuccess";

export default function ResetPassword() {
  const [isSuccess, setIsSuccess] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [resetToken, setResetToken] = useState<string | null>(null);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Get token from URL query parameters
    const params = new URLSearchParams(location.search);
    const token = params.get('token');
    
    if (!token) {
      setError("Invalid or missing reset token. Please try the password reset process again.");
      return;
    }
    
    setResetToken(token);
  }, [location]);
  
  const handleSuccess = () => {
    setIsSuccess(true);
    // Redirect to login after 3 seconds
    setTimeout(() => {
      navigate('/login');
    }, 3000);
  };

  if (error) {
    return (
      <div className="flex min-h-screen items-center justify-center p-4 sm:p-6 lg:p-8">
        <ResetPasswordError error={error} />
      </div>
    );
  }

  if (isSuccess) {
    return (
      <div className="flex min-h-screen items-center justify-center p-4 sm:p-6 lg:p-8">
        <ResetPasswordSuccess />
      </div>
    );
  }

  return (
    <div className="flex min-h-screen items-center justify-center p-4 sm:p-6 lg:p-8">
      <Card className="w-full max-w-md">
        <CardHeader className="space-y-1">
          <CardTitle className="text-2xl font-bold">Reset Password</CardTitle>
          <CardDescription>
            Enter your new password below.
          </CardDescription>
        </CardHeader>
        <CardContent>
          {resetToken && <ResetPasswordForm resetToken={resetToken} onSuccess={handleSuccess} />}
        </CardContent>
      </Card>
    </div>
  );
}
